import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
  })
  export class JsonFormatterService{
    cleanData(data: any): any {
      Object.keys(data).forEach((key) => {
          const value = data[key as keyof typeof data];
          if (typeof value === "string") {
              const trimmedValue = value.trim();
              if (trimmedValue === "")delete data[key as keyof typeof data];
              else data[key as keyof typeof data] = trimmedValue;
          } else if (typeof value === "object" && value !== null) {
              data[key as keyof typeof data] = this.cleanData(value);
          }
      });
      return data;
    }
  }